import { styled, Text } from '@zeiss/beyond-online-react';

export const ErrorText: typeof Text = styled(Text)`
  color: var(--color-global-text-error);
`;
